<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->

        </base-header>

        <div class="container-fluid mt--7">
            <div class="card card-profile shadow">
                <div class="card-header">
                    <div class="row">
                        <div class="col-12 col-sm-3 align-self-center"><h3 class="mb-0">Edit task</h3><small class="text-muted">{{formName}}</small></div>
                        <div class="col-12 col-sm-9 text-right align-self-center">
                            <router-link :to="{ name: 'policies' }" class=" btn btn-secondary mt-1">
                                <i class="fa fa-arrow-left"> Go back</i>
                            </router-link>
                            <button class="btn btn-success text-white mt-1" v-on:click="UpdateForm()">
                                <i class="fas fa-save"> Save</i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body pt-0 pt-md-4 bg-white">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group" v-if="errors.length">
                                <div class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <ul>
                                        <li v-for="error in errors" :key="error['.key']">{{ error }}</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="jumbotron">
                                    <h1 class="display-3"><span class="font-weight-bold text-primary d-inline-block">{{defaultStepDescriptions[currentStatus].step}}.</span> {{defaultStepDescriptions[currentStatus].title}}</h1>
                                    <p class="lead">{{defaultStepDescriptions[currentStatus].description}}</p>
                                    <hr class="my-4">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div v-for="(substatus, key) of currentSubStatuses[currentStatus].substatuses" :key="substatus.id">
                                                <confirmation-checkbox @change="stepCheckboxListener($event, key, substatus.id)" class="mb-3" v-model="substatus.completed"
                                                                       :disabled="substatus.completed || (key != 0 && !currentSubStatuses[currentStatus]['substatuses'][key-1]['completed'])"
                                                                       :confirmationMessage="config.checkboxConfirmationMessage">
                                                    <span v-bind:style="{ textDecoration: substatus.completed ? 'line-through': 'none' }">{{substatus.title}}</span>
                                                </confirmation-checkbox>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <textarea v-model="taskNotes" class="form-control" placeholder="Task notes. Example: important client" rows="3"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center mt-5">
                                        <small>SCROLL DOWN TO SEE THE DOCUMENT DETAILS</small><br><i class="fas fa-chevron-down animation-up-down"></i>
                                    </div>
                                </div>
                                <div class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#general-details"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="general-details">
                                                    <h3 class="mb-0">
                                                        General details<i class="align-middle ml-2 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="general-details" class="col-12 card-body collapse">
                                        <div class="row">
                                            <div class="col-3">
                                                <div class="form-group has-label">
                                                    <label class="form-control-label">Insurance Plan</label>
                                                    <select class="form-control" v-model="formInsurancePlan">
                                                        <option value="Comprehensive">Comprehensive</option>
                                                        <option value="Third Party">Third Party</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="form-group has-label">
                                                    <label class="form-control-label">Policy status</label>
                                                    <select class="form-control" v-model="formStatus">
                                                        <option value="request">New request</option>
                                                        <option value="processing">Processing</option>
                                                        <option value="payment_pending">Payment Pending</option>
                                                        <option value="in_force">In force</option>
                                                        <option value="expired">Expired</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <base-input alternative=""
                                                            :required="formStatus != 'request'"
                                                            type="number"
                                                            label="Policy premium"
                                                            placeholder="Enter premium amount"
                                                            input-classes="form-control-alternative"
                                                            v-model="formPremium" />
                                            </div>
                                        </div>
                                        <div class="row align-items-center">
                                            <div class="col-6">
                                                <div class="form-group has-label">
                                                    <label class="form-control-label">Insurance company</label>
                                                    <select class="form-control" v-model="insuranceCompanyTitle">
                                                        <option value="">– Select company –</option>
                                                        <option v-for="(company, key) of companies" :key="key" :value="company.title">{{company.title}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <router-link :to="{ name: 'company data', params: { id: undefined } }" class=" btn btn-sm btn-primary">+ Add new insurance company</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="user" class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#proposer-details"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="proposer-details">
                                                    <h3 class="mb-0">
                                                        Details of proposer<i class="align-middle ml-2 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="proposer-details" class="table-responsive collapse">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Field</th>
                                                    <th width="40%">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="font-weight-bolder">First Name</td>
                                                    <td>{{ user.firstName }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Last Name</td>
                                                    <td>{{ user.lastName }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Email</td>
                                                    <td>{{ user.email }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Phone</td>
                                                    <td>{{ user.phone }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="formStatus == 'in_force'" class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#payment-details"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="payment-details">
                                                    <h3 class="mb-0">
                                                        Payment Details<i class="ml-1 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="payment-details" class="table-responsive collapse">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Field</th>
                                                    <th width="40%">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="font-weight-bolder">Stripe payment ID</td>
                                                    <td>{{ policy.paymentId }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Stripe payment balance transaction ID</td>
                                                    <td>{{ policy.paymentBalanceTransaction }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Stripe payment date</td>
                                                    <td>{{ policy.paymentCreatedDate | readableTimestampDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Stripe payment reciept URL</td>
                                                    <td><a target="_blank" :href="policy.paymentReceiptUrl">View</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="user" class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#insurance-period"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="insurance-period">
                                                    <h3 class="mb-0">
                                                        Period of insurance<i class="align-middle ml-2 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="insurance-period" class="col-12 card-body collapse">
                                        <div class="row">
                                            <div class="form-group col-6">
                                                <label class="form-control-label">Start date</label>
                                                <div class="input-group">
                                                    <flat-pickr v-model="fromDate"
                                                                class="form-control"
                                                                :config="config"
                                                                placeholder="Select date"
                                                                name="fromDate">
                                                    </flat-pickr>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-default" type="button" title="Toggle" data-toggle>
                                                            <i class="fa fa-calendar">
                                                                <span aria-hidden="true" class="sr-only">Toggle</span>
                                                            </i>
                                                        </button>
                                                        <button class="btn btn-default" type="button" title="Clear" data-clear>
                                                            <i class="fa fa-times">
                                                                <span aria-hidden="true" class="sr-only">Clear</span>
                                                            </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-6">
                                                <base-input alternative="" :readonly="true"
                                                            label="End date"
                                                            input-classes="form-control"
                                                            :value="toDate" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Vehicle details -->
                                <div class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#vehicle-details"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="vehicle-details">
                                                    <h3 class="mb-0">
                                                        Details of insured vehicle<i class="align-middle ml-2 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                            <div class="col text-right">
                                                <img class="manufacturer-logo" v-bind:src="'https://doitcare-3c771.web.app/assets/img'+carData.logo" alt="Car logo">
                                            </div>
                                        </div>
                                    </div>
                                    <div id="vehicle-details" class="table-responsive collapse">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Field</th>
                                                    <th width="40%">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="font-weight-bolder">Make</td>
                                                    <td>{{ carData.makeTitle }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Model</td>
                                                    <td>{{ carData.modelTitle }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Generation
                                                        <div v-if="carData.image" class="mt-3">
                                                            <a class="btn btn-primary" data-toggle="collapse" href="#collapseReferenceImage" role="button" aria-expanded="false" aria-controls="collapseExample">Show generation image<sup>&#42;</sup></a>
                                                            <div><small><sup>&#42;</sup>Detected automatically, for the reference only</small></div>
                                                            <div class="collapse" id="collapseReferenceImage">
                                                                <img class="mt-2 rounded-sm" v-bind:src="'https://doitcare-3c771.web.app/assets/img'+carData.image" alt="Car image">
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{{ carData.generationTitle }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Year</td>
                                                    <td>{{ carData.year }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Registration Number</td>
                                                    <td>{{ carData.registrationNumber }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Body Type</td>
                                                    <td>{{ carData.bodyType }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Engine Type</td>
                                                    <td>{{ carData.engineType }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Cubic Capacity</td>
                                                    <td>{{ carData.cubicCapacity }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Proposer Estimated Value</td>
                                                    <td>{{ currencyCode +' '+ carData.proposerEstimatedValue }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Are you the legal owner of the car?</td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="isLegalOwner" v-model="carData.isLegalOwner">
                                                            <label class="custom-control-label" for="isLegalOwner">{{carData.isLegalOwner ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Is the car registered on your name?<base-input v-if="!carData.isRegisteredOnOwner" alternative="" :readonly="false"
                                                                                                       label="Details"
                                                                                                       labelClasses="mt-2 text-primary"
                                                                                                       placeholder=""
                                                                                                       input-classes="form-control-alternative"
                                                                                                       v-model="carData.isRegisteredOnOwnerDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="isRegisteredOnOwner" v-model="carData.isRegisteredOnOwner">
                                                            <label class="custom-control-label" for="isRegisteredOnOwner">{{carData.isRegisteredOnOwner ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Does the car have a M.O.T. Certificate?</td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="motSwitch" v-model="carData.hasMotCertificate">
                                                            <label class="custom-control-label" for="motSwitch">{{carData.hasMotCertificate ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Has the car's body or engine been modified from its original manufacture?
                                                        <base-input v-if="carData.isModified" alternative="" :readonly="false"
                                                                    label="Modification details"
                                                                    labelClasses="mt-2 text-primary"
                                                                    placeholder=""
                                                                    input-classes="form-control-alternative"
                                                                    v-model="carData.isModifiedDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="isModified" v-model="carData.isModified">
                                                            <label class="custom-control-label" for="isModified">{{carData.isModified ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Is the car subject to hire purchase agreement?<base-input v-if="carData.isHirePurchaseAgreement" alternative="" :readonly="false"
                                                                                                                  label="Details"
                                                                                                                  labelClasses="mt-2 text-primary"
                                                                                                                  placeholder=""
                                                                                                                  input-classes="form-control-alternative"
                                                                                                                  v-model="carData.hirePurchaseAgreementDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="isHirePurchaseAgreement" v-model="carData.isHirePurchaseAgreement">
                                                            <label class="custom-control-label" for="isHirePurchaseAgreement">{{carData.isHirePurchaseAgreement ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="carPictures">
                                                    <td colspan="2" class="font-weight-bolder">
                                                        <a class="btn btn-primary" data-toggle="collapse" href="#collapseUserImages" role="button" aria-expanded="false" aria-controls="collapseExample">Show user submitted car images</a>
                                                        <div class="collapse row" id="collapseUserImages">
                                                            <div class="col-3" v-for="(picture, key) of carPictures" :key="picture['.key']">
                                                                <expandable-image class="mt-2 rounded-sm w-100" v-bind:src="picture" alt="Car image" />
                                                                <caption>Car image #{{key+1}}</caption>
                                                            </div>
                                                            <div class="col-3" v-if="carData.carTitle">
                                                                <expandable-image title="Car title" class="mt-2 rounded-sm w-100" v-bind:src="carData.carTitle" alt="Car title" />
                                                                <caption>Car title</caption>
                                                            </div>
                                                            <div class="col-3" v-if="carData.purchaseAgreement">
                                                                <expandable-image title="Car purchase agreement" class="mt-2 rounded-sm w-100" v-bind:src="carData.purchaseAgreement" alt="Car purchase agreement" />
                                                                <caption>Car purchase agreement</caption>
                                                            </div>
                                                            <div class="col-3" v-if="carData.carInsuranceCertificate">
                                                                <expandable-image title="Car insurance certificate" class="mt-2 rounded-sm w-100" v-bind:src="carData.carInsuranceCertificate" alt="Car insurance certificate" />
                                                                <caption>Car insurance shedule</caption>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- Driver details -->
                                <div v-if="user" class="card shadow mb-4">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <a data-toggle="collapse"
                                                   class="collapsed"
                                                   href="#drivers-details"
                                                   role="button"
                                                   aria-expanded="false"
                                                   aria-controls="proposer-details">
                                                    <h3 class="mb-0">
                                                        Details of named drivers<i class="align-middle ml-2 fas"></i>
                                                    </h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="drivers-details" class="table-responsive collapse">
                                        <table class="table table-flush" v-for="(driver, key) of drivers" :key="key">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Driver #{{key+1}}</th>
                                                    <th width="40%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="font-weight-bolder">First Name</td>
                                                    <td>{{ driver.firstName }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Last Name</td>
                                                    <td>{{ driver.lastName }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Date of birth</td>
                                                    <td>{{ driver.dob | readableDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Driving experience</td>
                                                    <td>{{ driver.drivingExperience}} years</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">Id number</td>
                                                    <td>{{ driver.idNumber}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Any disease?<p class="small">Is the driver suffer from impaired vision, hearing or any other incapacity, diabetes, epilipsy, heart disease or any other illness or mental disease?</p>
                                                        <base-input v-if="driver.hasAnyDisease" alternative="" :readonly="false"
                                                                    label="Disease details"
                                                                    labelClasses="mt-2 text-primary"
                                                                    placeholder=""
                                                                    input-classes="form-control-alternative"
                                                                    v-model="driver.anyDiseaseDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="hasAnyDisease" v-model="driver.hasAnyDisease">
                                                            <label class="custom-control-label" for="hasAnyDisease">{{driver.hasAnyDisease ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Traffic accidents?<p class="small">Has the driver been involved in any traffic accident during the last 3 (three) years?</p><base-input v-if="driver.hasAccidents" alternative="" :readonly="false"
                                                                                                                                                                                                label="Accidents details"
                                                                                                                                                                                                labelClasses="mt-2 text-primary"
                                                                                                                                                                                                placeholder=""
                                                                                                                                                                                                input-classes="form-control-alternative"
                                                                                                                                                                                                v-model="driver.accidentsDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="hasAccidents" v-model="driver.hasAccidents">
                                                            <label class="custom-control-label" for="hasAccidents">{{driver.hasAccidents ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Traffic offence or violation?<p class="small">Has the driver been convicted of a traffic offence or violation during the last 3 (three) years?</p><base-input v-if="driver.hasTrafficOffence" alternative="" :readonly="false"
                                                                                                                                                                                                                      label="Offence details"
                                                                                                                                                                                                                      labelClasses="mt-2 text-primary"
                                                                                                                                                                                                                      placeholder=""
                                                                                                                                                                                                                      input-classes="form-control-alternative"
                                                                                                                                                                                                                      v-model="driver.trafficOffenceDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="hasTrafficOffence" v-model="driver.hasTrafficOffence">
                                                            <label class="custom-control-label" for="hasTrafficOffence">{{driver.hasTrafficOffence ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Insurance rejections<p class="small">Has any insurance company at any time rejected, required increased premium, imposed any special terms or conditions, refused to renew, cancelled any insurance policy?</p><base-input v-if="driver.hasInsuranceRejections" alternative="" :readonly="false"
                                                                                                                                                                                                                                                                                   label="Rejection details"
                                                                                                                                                                                                                                                                                   labelClasses="mt-2 text-primary"
                                                                                                                                                                                                                                                                                   placeholder=""
                                                                                                                                                                                                                                                                                   input-classes="form-control-alternative"
                                                                                                                                                                                                                                                                                   v-model="driver.hasInsuranceRejectionsDetails" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="hasInsuranceRejections" v-model="driver.hasInsuranceRejections">
                                                            <label class="custom-control-label" for="hasInsuranceRejections">{{driver.hasInsuranceRejections ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="font-weight-bolder">
                                                        Previous insurance<p class="small">Did the driver have an insurance of any other vehicle?</p><base-input v-if="driver.hasPreviousInsurance" alternative="" :readonly="false"
                                                                                                                                                                 label="Company name"
                                                                                                                                                                 labelClasses="mt-2 text-primary"
                                                                                                                                                                 placeholder=""
                                                                                                                                                                 input-classes="form-control-alternative"
                                                                                                                                                                 v-model="driver.previousInsuranceCompanyName" />
                                                        <base-input v-if="driver.hasPreviousInsurance" alternative="" :readonly="false"
                                                                    label="Policy number (optional)"
                                                                    labelClasses="text-primary"
                                                                    placeholder=""
                                                                    input-classes="form-control-alternative"
                                                                    v-model="driver.previousInsurancePolicyNumber" />
                                                    </td>
                                                    <td>
                                                        <div class="custom-control custom-switch">
                                                            <input type="checkbox" class="custom-control-input" id="hasPreviousInsurance" v-model="driver.hasPreviousInsurance">
                                                            <label class="custom-control-label" for="hasPreviousInsurance">{{driver.hasPreviousInsurance ? 'Yes':'No'}}</label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" class="font-weight-bolder">
                                                        <div class="row">
                                                            <div class="col-3" v-for="(picture, key) of driver.idPictures" :key="picture['.key']">
                                                                <expandable-image class="mt-2 rounded-sm w-100" v-bind:src="picture" alt="Document" />
                                                                <caption>Document picture #{{key+1}}</caption>
                                                            </div>
                                                            <div class="col-3" v-for="(picture, key) of driver.driverLicensePictures" :key="picture['.key']">
                                                                <expandable-image class="mt-2 rounded-sm w-100" v-bind:src="picture" alt="Driver license" />
                                                                <caption>Driver license picture #{{key+1}}</caption>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <!-- Insurance files -->
                                <div class="card shadow">
                                    <div class="card-header border-0 bg-transparent">
                                        <div class="row align-items-center">
                                            <div class="col-md-4">
                                                <h3 class="mb-0">
                                                    Insurance Files
                                                </h3>
                                            </div>
                                            <div class="col-md-8 text-right align-self-center">
                                                <button class=" btn btn-primary text-white mt-1"
                                                        data-toggle="modal" data-target="#fileUpload">
                                                    <i class="fa fa-plus"></i> Upload
                                                </button>
                                                <button style="min-width: 225px;" class="text-center btn btn-info text-white mt-1" v-on:click="generatePdf()">
                                                    <i class="fas fa-file-pdf"></i> {{ loadingPdf ? 'Loading...':'Generate quotation PDF' }}
                                                </button>
                                                <button style="min-width: 232px;" class="text-center btn btn-info text-white mt-1" v-on:click="generateCoverNotePdf()">
                                                    <i class="fas fa-file-pdf"></i> {{ loadingCoverNotePdf ? 'Loading...':'Generate cover note PDF' }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-flush">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Upload Date</th>
                                                    <th class="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(file, index) of allFiles" :key="file['.key']">
                                                    <td class="font-weight-bolder">{{ file.title }}<br><span class="font-weight-lighter">{{ file.description}}</span></td>
                                                    <td>{{ file.date | readableDateTime }}</td>
                                                    <td class="text-center">
                                                        <button @click="openFile(file, index)" type="button"
                                                                class="btn btn-sm btn-info btn-icon-only rounded-circle mt-1">
                                                            <i v-bind:class="{ 'fa fa-eye' : index != activeButtonIndex, 'fas fa-sync fa-spin': index == activeButtonIndex }"></i>
                                                        </button>
                                                        <button @click="deleteFile(file)" type="button"
                                                                class="btn btn-sm btn-danger btn-icon-only rounded-circle mt-1">
                                                            <i class="fa fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group" id="formBuilder1">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Start New data record Modal -->
        <div class="modal fade" id="fileUpload" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">New File Upload</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent id="formRender">
                            <base-input alternative=""
                                        :required="true"
                                        type="text"
                                        label="Enter a file description"
                                        placeholder="Cover Note #XXX"
                                        input-classes="form-control"
                                        v-model="fileDescription" />
                            <div class="custom-file">
                                <input :disabled="!fileDescription" type="file" class="custom-file-input" id="files" name="file" ref="uploadInput"
                                       :multiple="false" @change="detectFiles($event)">
                                <label class="custom-file-label" for="files">Select file</label>
                            </div>
                            <div v-if="uploading && !uploadEnd" class="progress-wrapper">
                                <div class="progress-info">
                                    <div class="progress-label">
                                        <span>Uploading</span>
                                    </div>
                                    <div class="progress-percentage">
                                        <span> {{progressUpload}}%</span>
                                    </div>
                                </div>
                                <div class="progress">
                                    <div class="progress-bar bg-success" role="progressbar"
                                         :aria-valuenow="progressUpload" :style="{'width': `${progressUpload}%`}"></div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- End New data record Modal -->
    </div>
</template>
<script>

    /* eslint-disable */
    window.$ = window.jQuery = require('jquery');
    require('jquery-ui-sortable');
    window.$ = window.jQuery = require('jquery');
    import firebase from '../config/db.js';
    import { firestorage } from '../config/db.js';
    import { analytics } from '../config/db.js';
    require('bootstrap/dist/js/bootstrap.js');

    import swal from 'sweetalert2'
    import moment from 'moment'
    import Vue from "vue";
    import UUID from "vue-uuid";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import VueExpandableImage from 'vue-expandable-image'
    Vue.use(VueExpandableImage)
    Vue.use(UUID);

    export default {
        name: 'task-update',
        data() {
            var that = this;
            return {
                companies: [],
                progressUpload: 0,
                currentStatus: 0,
                currentSubStatuses: [
                    { substatuses: [] }, { substatuses: [] }, { substatuses: [] }, { substatuses: [] }
                ],
                taskNotes: '',
                defaultStepDescriptions: [
                    {
                        title: 'Quotation request submitted by user',
                        step: 1,
                        description: 'User uploaded details for quotation request',
                        substatuses: [
                            {
                                id: 1,
                                title: 'Review by broker',
                                completed: false
                            },
                            {
                                id: 2,
                                title: 'Send by email/upload files to the Insurance company',
                                description: 'Quotation request processed',
                                completed: false
                            },
                            {
                                id: 3,
                                title: 'Quotation received from the Insurance company',
                                completed: false
                            }
                        ]
                    },
                    {
                        title: 'Quotation uploaded to the user',
                        step: 2,
                        description: 'Quotation received from the insurance company',
                        substatuses: [
                            {
                                id: 4,
                                title: 'Notification sent to the user',
                                completed: false
                            },
                            {
                                id: 5,
                                title: 'Ensure that we upload the correct quotation',
                                completed: false
                            },
                            {
                                id: 6,
                                title: 'Time left to accept the quotation:',
                                description: 'Quotation sent to the user',
                                completed: false
                            }
                        ]
                    },
                    {
                        title: 'Received acceptance from customer',
                        step: 3,
                        description: 'Customer accepted and paid',
                        substatuses: [
                            {
                                id: 7,
                                title: 'Confirmation to user: payment received, policy issue in progress',
                                completed: false
                            },
                            {
                                id: 8,
                                title: 'Cover note issued, notification sent to the user',
                                completed: false
                            },
                            {
                                id: 9,
                                title: 'Email to the insurance company to issue the policy with details of the payment',
                                description: 'Policy issue in progress',
                                completed: false
                            }
                        ]
                    },
                    {
                        title: 'Policy received from the insurance company',
                        step: 4,
                        description: '',
                        substatuses: [
                            {
                                id: 10,
                                title: 'Notification to the user: your policy has been issued',
                                completed: false
                            },
                            {
                                id: 11,
                                title: 'Upload the policy to the customer',
                                description: 'Policy issued',
                                completed: false
                            }
                        ]
                    }
                ],
                fileName: '',
                activeButtonIndex: -1,
                uploadTask: '',
                uploading: false,
                loadingPdf: false,
                loadingCoverNotePdf: false,
                uploadEnd: false,
                currentDate: '',
                allFiles: [],
                fileDescription: '',
                errors: [],
                formName: '',
                carData: [],
                carPictures: [],
                policy: [],
                drivers: [],
                formInsurancePlan: '',
                formStatus: '',
                formPremium: '',
                insuranceCompanyTitle: '',
                insuranceCompanyPhone: '',
                currencyCode: '',
                fromDate: '',
                fromDateObject: '',
                toDate: '',
                toDateObject: '',
                user: '',
                userId: '',
                config: {
                    wrap: true,
                    enableTime: true,
                    dateFormat: "F J Y, H:i:S K",
                    onChange: function (selectedDates, dateStr, instance) {
                        that.toDate = moment(dateStr, 'MMMM Do YYYY, h:mm:ss A').add(1, 'year').subtract(1, 'day').hour(23).minutes(59).seconds(59).format('MMMM Do YYYY, h:mm:ss A');
                        that.fromDateObject = moment(dateStr, 'MMMM Do YYYY, h:mm:ss A').toDate();
                        that.toDateObject = moment(dateStr, 'MMMM Do YYYY, h:mm:ss A').add(1, 'year').subtract(1, 'day').hour(23).minutes(59).seconds(59).toDate();
                    },
                    checkboxConfirmationMessage: "You won't be able to revert this!",
                },
                id: this.$router.currentRoute.params.id,
            }
        },
        components: {
            flatPickr
        },
        mounted() {
            var docRef = firebase.firestore().collection("policies").doc(this.id);
            var that = this;
            docRef.get().then(function (doc) {
                if (doc.exists) {
                    that.policy = doc.data();
                    that.formStatus = doc.data().status;
                    that.formPremium = doc.data().premium;
                    that.insuranceCompanyTitle = doc.data().insuranceCompanyTitle;
                    that.insuranceCompanyPhone = doc.data().insuranceCompanyPhone;
                    that.currencyCode = doc.data().currencyCode;
                    that.formInsurancePlan = doc.data().insurancePlan;
                    that.fromDate = doc.data().fromDateTime.toDate();
                    that.fromDateObject = doc.data().fromDateTime;
                    that.toDate = moment(doc.data().toDateTime.toDate()).format('MMMM Do YYYY, h:mm:ss A');
                    that.toDateObject = doc.data().toDateTime;
                    that.carData = doc.data().vehicle;
                    that.formName = doc.id;
                    that.drivers = doc.data().drivers;
                    that.allFiles = doc.data().attachments ? doc.data().attachments : [];
                    that.taskNotes = doc.data().taskNotes ? doc.data().taskNotes : '';
                    if (doc.data().vehicle.pictures.length > 0) {
                        that.carPictures = doc.data().vehicle.pictures;
                    }
                    if (doc.data().author) {
                        that.userId = doc.data().author;
                        var userRef = firebase.firestore().collection("users").doc(doc.data().author);
                        userRef.get().then(function (userDoc) {
                            if (userDoc.exists) {
                                that.user = userDoc.data();
                            }
                        });
                    }
                    if (doc.data().internalStatus >= 0 && doc.data().internalSubStatuses && doc.data().internalSubStatuses.length > 0) {
                        that.setInternalStep(doc.data().internalStatus, doc.data().internalSubStatuses);
                    } else {
                        that.setInternalStep(0, that.defaultStepDescriptions);
                    }
                } else {
                    // doc.data() will be undefined in this case
                    swal.fire({
                        text: 'No such document!',
                        type: "error",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    that.$router.replace('policies')
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
            var collection = [];
            firebase.firestore().collection("companies").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    collection.push(doc.data());
                });
            });
            this.companies = collection;
        },
        methods: {
            stepCheckboxListener(event, index, subStatusId) {
                if (this.currentSubStatuses[this.currentStatus].substatuses.every(subStatus => subStatus.completed)) {
                    if (this.currentStatus < this.defaultStepDescriptions.length - 1) {
                        this.currentStatus++;
                    }
                }

                var that = this;
                firebase.firestore().collection("policies").doc(this.id).update({
                    'internalStatus': that.currentStatus,
                    'internalSubStatuses': that.currentSubStatuses,
                }).then(function () {
                    swal.fire({
                        text: "Policy updated successfully...",
                        type: "success",
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }).catch(function (error) {
                    console.error("Error saving status: ", error);
                });

                // TODO
                if (event) {
                    //this.currentSubStatuses[this.currentStatus].substatuses[index].completed = false;
                }
            },
            setInternalStep(step, substatuses) {
                if (Number.isInteger(step) && substatuses.length > 0) {
                    this.currentStatus = step;
                    this.currentSubStatuses = substatuses;
                } else {
                    this.currentStatus = 0;
                    this.currentSubStatuses = this.defaultStepDescriptions;
                }
            },
            generateCoverNotePdf() {
                if (this.loadingCoverNotePdf || !this.formName || !this.userId) {
                    return;
                }
                var functionData = {
                    policy: this.formName,
                    user: this.userId
                };
                var that = this;
                this.loadingCoverNotePdf = true;
                fetch('https://europe-west1-doitcare-3c771.cloudfunctions.net/generateCoverNotePdf', {
                    body: JSON.stringify(functionData),
                    method: 'POST',
                    mode: 'cors',
                }).then(response => response.json())
                    .then((result) => {
                        that.loadingCoverNotePdf = false;
                        // Read result of the Cloud Function.
                        swal.fire({
                            icon: 'success',
                            showCloseButton: true,
                            showConfirmButton: false,
                            confirmButtonText: 'Close',
                            html:
                                '<h2>The document generated successfully.</h2><h3 class="mt-4 mb-0"><a class="btn btn-primary" target="_blank" download href="' + result.data.url + '">Download the PDF</a></h3><small>The link will be expire in one hour.</small>',
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        that.loadingCoverNotePdf = false;
                        swal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            text: error
                        });
                    });
            },
            generatePdf() {
                if (this.loadingPdf || !this.formName || !this.userId) {
                    return;
                }
                var functionData = {
                    policy: this.formName,
                    user: this.userId
                };
                var that = this;
                this.loadingPdf = true;
                fetch('https://europe-west1-doitcare-3c771.cloudfunctions.net/generatePdf', {
                    body: JSON.stringify(functionData),
                    method: 'POST',
                    mode: 'cors',
                }).then(response => response.json())
                    .then((result) => {
                        that.loadingPdf = false;
                        // Read result of the Cloud Function.
                        swal.fire({
                            icon: 'success',
                            showCloseButton: true,
                            showConfirmButton: false,
                            confirmButtonText: 'Close',
                            html:
                                '<h2>The document generated successfully.</h2><h3 class="mt-4 mb-0"><a class="btn btn-primary" target="_blank" download href="' + result.data.url + '">Download the PDF</a></h3><small>The link will be expire in one hour.</small>',
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        that.loadingPdf = false;
                        swal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            text: error
                        });
                    });
            },
            selectFile() {
                this.$refs.uploadInput.click()
            },
            detectFiles(e) {
                let fileList = e.target.files || e.dataTransfer.files
                Array.from(Array(fileList.length).keys()).map(x => {
                    this.upload(fileList[x])
                })
            },
            upload(file) {
                this.fileName = file.name
                this.uploading = true
                this.uploadTask = firestorage.ref('policyUploads/' + this.$router.currentRoute.params.id + '/' + file.name).put(file);
                this.currentDate = new Date();
            },
            downloadFile(filename, key) {
                firestorage.ref('policyUploads/' + this.$router.currentRoute.params.id + '/').child(filename).getDownloadURL().then(function (url) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url, true);
                    xhr.responseType = "blob";
                    xhr.onload = function () {
                        var urlCreator = window.URL || window.webkitURL;
                        var imageUrl = urlCreator.createObjectURL(this.response);
                        var tag = document.createElement('a');
                        tag.href = imageUrl;
                        tag.download = filename;
                        document.body.appendChild(tag);
                        tag.click();
                        document.body.removeChild(tag);
                    }
                    xhr.send();

                }).catch(function (error) {
                    // Handle any errors
                });
            },
            openFile(file, index) {
                this.activeButtonIndex = index;

                var that = this;
                firestorage.ref('policyUploads/' + this.$router.currentRoute.params.id + '/' + file.title).getDownloadURL().then(function (url) {
                    that.activeButtonIndex = -1;
                    window.open(url);
                }).catch(function (error) {
                    that.activeButtonIndex = -1;
                    console.error("Error opening document: ", error);
                });
            },
            deleteFile(file) {
                var that = this;
                swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    icon: "warning",
                    showCancelButton: !0,
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then(function (result) {
                    if (result.value) {
                        let index = that.allFiles.indexOf(file);
                        that.allFiles.splice(index, 1);

                        firebase.firestore().collection("policies").doc(that.$router.currentRoute.params.id).update({
                            'attachments': that.allFiles
                        }).catch(function (error) {
                            console.error("Error updating policy attachments", error);
                        });

                        firestorage
                            .ref('policyUploads/' + that.$router.currentRoute.params.id + '/' + file.title)
                            .delete()
                            .then(() => {

                            })
                            .catch((error) => {
                                console.error(`file delete error occured: ${error}`);
                            })
                    }
                }, function (t) {
                    "cancel" === t && swal("Cancelled", "Your file is safe :)", "error")
                });
                this.uploading = false;
                this.uploadEnd = false;
            },
            UpdateForm: function () {
                this.errors = [];
                if (this.formName == '') {
                    this.errors.push('Document ID is required!');
                }
                if (this.formStatus != 'request' && !this.formPremium) {
                    this.errors.push('Premium is required!');
                }
                if (this.formStatus != 'request' && !this.insuranceCompanyTitle) {
                    this.errors.push('Please fill the Insurance company name');
                }
                if (this.formStatus != 'request' && this.allFiles.length == 0) {
                    this.errors.push('Upload a policy file(s)');
                }
                if (!this.toDate || !this.toDateObject || !this.fromDate || !this.fromDateObject) {
                    this.errors.push('Please enter the effective dates');
                }
                var that = this;
                if (this.errors.length == 0) {
                    firebase.firestore().collection("policies").doc(this.id).update({
                        'status': that.formStatus,
                        'internalStatus': that.currentStatus,
                        'internalSubStatuses': that.currentSubStatuses,
                        'taskNotes': that.taskNotes,
                        'attachments': that.allFiles,
                        'premium': parseFloat(that.formPremium),
                        'insuranceCompanyTitle': that.insuranceCompanyTitle,
                        'insuranceCompanyPhone': that.insuranceCompanyPhone,
                        'insurancePlan': that.formInsurancePlan,
                        'vehicle': that.carData,
                        'fromDateTime': that.fromDateObject,
                        'toDateTime': that.toDateObject
                    }).then(function () {

                        swal.fire({
                            text: "Policy updated successfully...",
                            type: "success",
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        that.$router.push({ name: 'policies' })
                    }).catch(function (error) {
                        console.error("Error writing document: ", error);
                    });
                }
            },
        },
        watch: {
            uploadTask: function () {
                var that = this;
                this.uploadTask.on('state_changed', sp => {
                    this.uploadEnd = false
                    this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
                },
                    null,
                    () => {
                        this.uploadEnd = true
                        $('#fileUpload').modal('hide');
                        that.allFiles.push(
                            {
                                'id': that.$uuid.v1(),
                                'title': this.fileName,
                                'description': that.fileDescription,
                                'date': new Date()
                            }
                        );

                        firebase.firestore().collection("policies").doc(that.$router.currentRoute.params.id).update({
                            'attachments': that.allFiles
                        }).catch(function (error) {
                            console.error("Error updating policy attachments", error);
                        });

                        swal.fire({
                            title: "Success!",
                            text: "Your file has been added.",
                            type: "success",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1500
                        });
                        that.fileDescription = '';
                    })
            }
        },
        filters: {
            readableDateTime: function (value) {
                if (!value || value == 'undefined') {
                    return '';
                } else if (value instanceof Date) {
                    return moment(value).format('MMMM Do YYYY, h:mm:ss A');
                } else {
                    return moment(value.toDate()).format('MMMM Do YYYY, h:mm:ss A');
                }
                return '';
            },
            readableDate: function (value) {
                if (!value || value == 'undefined') {
                    return '';
                } else if (value instanceof Date) {
                    return moment(value).format('MMMM Do YYYY');
                } else {
                    return moment(value.toDate()).format('MMMM Do YYYY');
                }
                return '';
            },
            readableTimestampDate: function (value) {
                if (!value || typeof value === 'undefined' || value == null) {
                    return 0;
                } else if (!isNaN(value)) {
                    return moment.unix(value).format('MMMM Do YYYY, h:mm:ss A');
                }
                return 0;
            }
        }

    };
</script>
<style></style>
